define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/resolver",
	"csi/comm",
	"csi/table/Copy",
	"csi/xml"
], function(declare,_,resolver,comm,Copy,xml) {

	return declare(Copy, {
		nameValue: "",
		quantity: 1,

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for quantity
			view.addDefaultValue("Quantity", 1);
			this.inherited(arguments);
		},
		
		_processSource: function(/*Node*/node) {
			var fd = this.m_formData;
			var	fName = fd.getField(xml.ATTR_NAME);
			var	name = fd.getFieldValue(xml.ATTR_NAME, true);
			
			this.quantity = parseInt(fd.getFieldValue("Quantity", true));
			
			if (this.quantity <= 0) {
				return;
			}
			
			if (!fName.isDefaultValue() || !fName.hasExpression()) {
				this.nameValue = name;
				
				if ((this.quantity > 1) && (name.indexOf("${0}") < 0)) {
					this.nameValue += "-${0}";
				}
			}

			this.m_value = comm.createUrls(this.quantity);
			this.m_urlNode = this.m_value[0];
			this.m_nodeSource = node;
			this._toWriterSource();
			this.toWriterFields(this.m_urlNode);
			this._onAction();
		},

		toWriter: function() {
			var	call = this.inherited(arguments);
			if (call) {
				call.addParameter("Name", xml.ATTR_STRING, this.nameValue);
				call.addParameter("Quantity", xml.ATTR_INTEGER, this.quantity);
				call.addParameter("NewNodeURLs", xml.ATTR_CNLLIST, this.m_value);
			}
			return call;
		}
	});
});
